import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


/**
 * Extract items from API response (paginated or non-paginated).
 * Paginated: { items, page, pageSize, total }
 * Non-paginated: { data: [...] }
 */
export function extractItems(response) {
  const d = response?.data;
  if (!d) return [];
  if (Array.isArray(d.items)) return d.items;
  if (Array.isArray(d.data)) return d.data;
  if (Array.isArray(d)) return d;
  return [];
}

export function extractPagination(response) {
  const d = response?.data;
  if (!d) return { page: 1, pageSize: 20, total: 0 };
  return { page: d.page || 1, pageSize: d.pageSize || 20, total: d.total || 0 };
}
